"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFormat = dateFormat;
exports.dateTimeStringFormat = dateTimeStringFormat;
exports.dateTimeStringSplit = dateTimeStringSplit;
exports.timeFormat = timeFormat;

// Turns a Date/Time string from server to Javscript Date object.
function dateTimeStringSplit(dateTimeString) {
  if (dateTimeString) {
    if (dateTimeString.split('T').length > 1) {
      var dateArray = dateTimeString.split('T')[0].split('-');
      var timeArray = dateTimeString.split('T')[1].split(':');
      timeArray[2] = timeArray[2].slice(0, 2); // cuts off occasional 'Z' at the end of the time stamp

      return new Date(dateArray[0], dateArray[1] - 1, dateArray[2], timeArray[0], timeArray[1], timeArray[2]);
    } else {
      var _dateArray = dateTimeString.split('T')[0].split('-');

      if (_dateArray.length === 1) {
        _dateArray = _dateArray[0].split('/');
        return new Date(_dateArray[2], _dateArray[0] - 1, _dateArray[1]);
      }

      return new Date(_dateArray[0], _dateArray[1] - 1, _dateArray[2]);
    }
  }
} // Formats a Date object for posting to servers


function dateTimeStringFormat(date) {
  return "".concat(singleDigitNumberFormat(date.getMonth() + 1)) + "/".concat(singleDigitNumberFormat(date.getDate())) + "/".concat(date.getFullYear());
} // Formats a Date object to a nice date string (MM/DD/YY)


function dateFormat(date) {
  if (date) {
    var year = date.getFullYear().toString();
    return "".concat(date.getMonth() + 1, "/").concat(date.getDate(), "/").concat(year.slice(2));
  } else {
    return null;
  }
} // Formats a Date object to a nice time string (HH:MM AM)


function timeFormat(date) {
  if (date) {
    var hour = date.getHours();
    var minutes = date.getMinutes();
    var period;

    if (hour <= 11) {
      if (hour < 1) {
        hour = 12;
      }

      period = 'AM';
    } else if (hour === 12) {
      period = 'PM';
    } else if (hour > 12) {
      hour -= 12;
      period = 'PM';
    }

    return "".concat(singleDigitNumberFormat(hour), ":").concat(singleDigitNumberFormat(minutes), " ").concat(period);
  }
} // Adds a '0' to a number that is a single digit


function singleDigitNumberFormat(num) {
  if (num < 10) {
    return "0".concat(num);
  }

  return num;
}